<template>
  <div class="pdf" v-show="fileType === 'pdf'">
    <pdf
      ref="pdf"
      :src="pdfUrl"
      :page="currentPage"
      @num-pages="pageCount=$event"
      @page-loaded="currentPage=$event"
      @loaded="loadPdfHandler">
    </pdf>
    <div class="bottom-btn" >
      <p class="arrow">
        <span @click="changePdfPage(0)" class="turn">上一页</span>
        {{currentPage}} / {{pageCount}}
        <span @click="changePdfPage(1)" class="turn">下一页</span>
      </p>
    </div>
  </div>
</template>
<script>

import pdf from "vue-pdf"
export default {
  components: {
    pdf
  },
  props:{
    pdfurl:{
      type:String,
      default:"" // 设置默认值
    }
  },
  data () {
    return {
      pdfUrl:this.pdfurl,
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: 'pdf', // 文件类型
      msg:"没有变化"
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
// 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage (val) {
      // console.log(val)
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++
      }
    },
    loadPdfHandler(e){
      this.currentPage = 1 // 加载的时候先加载第一页
    },
  }
}
</script>
<style scoped>
  .pdf{
    position: relative;
  }
  .bottom-btn{
    bottom: 0;
    background: #ffffff;
  }
  .arrow{
    text-align: center;
  }
  .turn{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Toolmain/pdfshow.vue